import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  CategoryDetailsCont,
  CategoryHeader,
  CategoryTitle,
  NumberOfImprovement,
  NumberOfImprovementCont,
  CategoryTitleCont,
  CloseOpenIconCont,
  RecommendationsCont,
} from './RecommendationCategoryDetails.styled';
import RecommendationTile from './RecommendationTIle/RecommendationTIle';
import { ERecommendationVariant } from '../../constans/report';
import { useFilters } from '../../hooks/useFilters';
import { useRecommendations } from '../../hooks/useRecommendations';
import { useScroll } from '../../hooks/useScroll';
import { IRecommendationItem } from '../../services/reports';
import CloseIcon from '@/assets/icons/closeAllAccordion.svg?react';
import OpenIcon from '@/assets/icons/openAllAccordion.svg?react';

interface IRecommendationCategoryDetails {
  recommendation: IRecommendationItem;
  variant: ERecommendationVariant;
}

const RecommendationCategoryDetails: FC<IRecommendationCategoryDetails> = ({
  recommendation: {
    category: { code, title },
    areasCount,
    areasOfImprovement,
  },
  variant,
}) => {
  const { t } = useTranslation();
  const { getNestedFilters, applyNestedFilter, applyFilters } = useFilters();
  const categoryKey = 'categories';
  const categoriesFilters = getNestedFilters(categoryKey);
  const active = categoriesFilters[code]?.active || false;
  const { getVariantDetails } = useRecommendations();
  const { color } = getVariantDetails(variant);
  const { isIntersecting } = useScroll(`${code}-${title}`, '0% 0% 0% 0%');

  const openCategory = () => {
    const isActive = !active;
    applyNestedFilter({ active: isActive ? [] : null }, code, categoryKey);
  };

  useEffect(() => {
    if (isIntersecting) {
      return applyFilters({ activeSection: `${code}-${title}` });
    }
  }, [code, isIntersecting, title]);

  return (
    <CategoryDetailsCont id={`${code}-${title}`} key={code} color={color}>
      <CategoryHeader id="CategoryHeader" isExpanded={active}>
        <CategoryTitleCont id="CategoryTitleCont" onClick={openCategory}>
          <CategoryTitle id="CategoryTitle">{title}</CategoryTitle>
          <CloseOpenIconCont id="CloseOpenIconCont">
            {active ? <CloseIcon id="CloseIcon" /> : <OpenIcon id="OpenIcon" />}
          </CloseOpenIconCont>
        </CategoryTitleCont>
        <NumberOfImprovementCont id="NumberOfImprovementCont">
          {t('report.recommendation.areasOfImprovement')}:
          <NumberOfImprovement id="NumberOfImprovement">{areasCount}</NumberOfImprovement>
        </NumberOfImprovementCont>
      </CategoryHeader>
      {active && (
        <RecommendationsCont id="RecommendationsCont">
          {areasOfImprovement.map((improvement, index) => {
            return (
              <RecommendationTile
                key={index}
                improvement={improvement}
                variant={variant}
                index={index}
                categoryCode={code}
              />
            );
          })}
        </RecommendationsCont>
      )}
    </CategoryDetailsCont>
  );
};

export default RecommendationCategoryDetails;
